/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_My_TasksInputs */



/**
* | output |
* | --- |
* | "My Tasks" |
*
* @param {Explorer_Nav_My_TasksInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_my_tasks = /** @type {((inputs?: Explorer_Nav_My_TasksInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_My_TasksInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mes taches")
	if (locale === "de") return /** @type {LocalizedString} */ ("Meine Aufgaben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Le mie attivita")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Мои задачи")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mis tareas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("我的任务")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マイタスク")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मेरे कार्य")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("As minhas tarefas")
	return /** @type {LocalizedString} */ ("My Tasks")
});